<template>
  <div v-show="isShow" class="home-nav" mg-stat-click mg-stat-custom="label=icon&cont=&direct=web&addr=haowu_home"
       @click="gotoHome">
    <i class="icon home_nav"></i>
  </div>
</template>
<script>
import DataStorage from 'utils/dataStore';
import { beforeRouteChange } from 'utils/uploadData';

export default {
  props: ['origin'],
  computed: {
    isShow() {
      return !DataStorage.getPrePage();
    },
  },
  methods: {
    gotoHome() {
      beforeRouteChange({ path: '/home' }, this.origin);
    },
  },
};
</script>
<style lang="scss" scoped>
.home-nav {
  position: fixed;
  bottom: 131px;
  right: 0;
  width: 104px;
  height: 63px;
}
</style>
